<div class="modal-header">
  <h4 class="modal-title">Google Integration Diagnostic</h4>
  <button type="button" class="btn btn-close" (click)="close()"></button>
</div>
<div class="modal-body">
  <app-google-integration-diagnostic-panel [customerId]="customerId" [isReadOnly]="isReadOnly">
  </app-google-integration-diagnostic-panel>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="close()">
    Close
  </button>
</div>
